// 用户管理
import request from '@/utils/userRequest'
let userBaseUrl = '/MetaWorks/api/v1/user/'
let userBaseUrl_k8s = '/MetaWorks/api/user/'
//获取用户列表
export function userList(data) {
  return request({
    url: userBaseUrl_k8s + 'v1/user/list',
    method: 'post',
    data,
  })
}
//用户菜单
export function dynamicList(params) {
  return request({
    url: userBaseUrl_k8s + 'v1/dynamic/list',
    method: 'get',
    params,
  })
}
//用户注册
export function userRegister(data) {
  return request({
    url: userBaseUrl_k8s + 'v1/user/register',
    method: 'post',
    data,
  })
}
//用户详情
export function userDetail(params) {
  return request({
    url: userBaseUrl_k8s + `v1/user/detail?id=${params.id}`,
    method: 'get',
  })
}
//用户注销
export function logOff(params) {
  return request({
    url: userBaseUrl_k8s + `v1/user/logOff?id=${params.id}`,
    method: 'get',
  })
}

//用户消息列表
export function userMessageList(data) {
  return request({
    url: userBaseUrl_k8s + `v1/info/list`,
    method: 'post',
    data,
  })
}
//用户消息详情
export function userInfoDetail(params) {
  return request({
    url: userBaseUrl_k8s + `v1/info/detail?messageId=${params.id}`,
    method: 'get',
  })
}
//站内消息删除
export function userMsgDelete(data) {
  return request({
    url: userBaseUrl_k8s + `v1/info/delete`,
    method: 'post',
    data,
  })
}

//修改密码
export function updatePassword(data) {
  return request({
    url: userBaseUrl_k8s + `v1/user/updatePassword`,
    method: 'post',
    data,
  })
}

/**
 *  获取可用平台
 */

// export function getPlatformListAPI() {
//   return request({
//     url: userBaseUrl_k8s + `v1/user/platform`,
//     method: 'post',
//   })
// }
//当前登录人详情
export function currUserInfo() {
  return request({
    url: userBaseUrl_k8s + `v1/user/account/info`,
    method: 'post',
  })
}
//绑定手机号
export function bindPhone(params) {
  return request({
    url: userBaseUrl_k8s + `v1/user/bindPhone?code=${params.code}&phone=${params.phone}`,
    method: 'get',
  })
}
//换绑手机号
export function updateBindPhone(data) {
  return request({
    url: userBaseUrl_k8s + 'v1/user/updateBindPhone',
    method: 'post',
    data,
  })
}

// 获取绑定验证码
export function bindSmsCode(params) {
  return request({
    url: userBaseUrl_k8s + `v1/user/login/getBindSmsCode?phone=${params.phone}`,
    method: 'get',
  })
}
// 获取注册验证码
export function getRegisterSmsCode(params) {
  return request({
    url: userBaseUrl_k8s + `v1/user/login/getRegisterSmsCode`,
    method: 'get',
    params,
  })
}
//消息中心多选删除
export function API_infoDelete(data) {
  return request({
    url: userBaseUrl_k8s + `v1/info/delete`,
    method: 'post',
    data,
  })
}
//消息中心已读
export function API_infoRead(data) {
  return request({
    url: userBaseUrl_k8s + `v1/info/viewed`,
    method: 'post',
    data,
  })
}

// 消息中心全部已读
export function API_allRead() {
  return request({
    url: userBaseUrl_k8s + `v1/info/batch/read`,
    method: 'get',
  })
}
// 用户消息未读数量
export function API_unReadCount() {
  return request({
    url: userBaseUrl_k8s + `v1/info/newInfo/count`,
    method: 'get',
  })
}
//微博用户授权
export function API_bindAuthToken(params) {
  return request({
    url: userBaseUrl_k8s + `v1/wb/bind_auth_token`,
    method: 'get',
    params,
  })
}
//唯品会授权绑定
export function API_wph_bindAuthToken(params) {
  return request({
    url: userBaseUrl_k8s + `v1/wph/bind_auth_token`,
    method: 'get',
    params,
  })
}
//淘宝授权绑定
export function API_tb_bindAuthToken(params) {
  return request({
    url: userBaseUrl_k8s + `v1/tb/bindAuthToken`,
    method: 'get',
    params,
  })
}

//判断用户是否已创建商品/视频（未创建不能进入创建直播）
export function API_listMerchandisVideo(data) {
  return request({
    url: '/MetaWorks/api/digitalhuman/v2/productVideo/listMerchandisVideo',
    method: 'post',
    data,
  })
}
//解绑京东等平台授权
export function unBindAuth(data) {
  return request({
    url: userBaseUrl_k8s + 'v1/user/unBindAuth',
    method: 'post',
    data,
  })
}

//1.8.20 接口

/**
 * 个人中心-获取验证码
 */
export function updatePasswordByPhoneAPI(data) {
  return request({
    url: userBaseUrl_k8s + 'v1/user/password/resetByVerificationCode',
    method: 'post',
    data,
  })
}
/**
 * 忘记密码-获取验证码
 */
export function getVerificationCodeAPI_forget(data) {
  return request({
    url: userBaseUrl_k8s + 'v1/user/password/getVerificationCode',
    method: 'post',
    data,
  })
}
/**
 * 忘记密码-通过手机号修改密码
 */
export function updatePasswordByPhoneAPI_forget(data) {
  return request({
    url: userBaseUrl_k8s + 'v1/user/password/resetByPhoneAndVerificationCode',
    method: 'post',
    data,
  })
}
/**
 * 账号信息
 */
export function getUserInfoAPI() {
  return request({
    url: userBaseUrl_k8s + 'v1/user/account/info',
    method: 'post',
  })
}
/**
 * 获取可用平台
 */
export function getPlatformListAPI() {
  return request({
    url: userBaseUrl_k8s + 'v1/user/platform',
    method: 'post',
  })
}
/**
 * 个人中心-换绑手机号
 */
export function updateBindPhoneAPI(data) {
  return request({
    url: userBaseUrl_k8s + 'v1/user/phone/resetByVerificationCode',
    method: 'post',
    data,
  })
}
/**
 * 个人中心-授权平台信息
 */
export function getAuthPlatformInfoAPI() {
  return request({
    url: userBaseUrl_k8s + 'v1/user/platform/auth/info',
    method: 'post',
  })
}
/**
 * 个人中心-第三方授权接口
 */
export function authorizePlatformAPI(data) {
  return request({
    url: userBaseUrl_k8s + 'v1/user/platform/authorize',
    method: 'post',
    data,
  })
}
/**
 * 个人中心-授权回调
 */
export function authorizePlatformCallBackAPI(data) {
  return request({
    url: userBaseUrl_k8s + 'v1/user/platform/authorize/callback',
    method: 'post',
    data,
  })
}
/**
 * 个人中心-平台更新
 */
export function updatePlatformAPI(data) {
  return request({
    url: userBaseUrl_k8s + 'v1/user/platform/update',
    method: 'post',
    data,
  })
}
/**
 * 个人中心-解绑平台
 */
export function unBindPlatformAPI(data) {
  return request({
    url: userBaseUrl_k8s + 'v1/user/platform/unBind',
    method: 'post',
    data,
  })
}
/**
 * 个人中心-获取验证码
 */
export function getVerificationCodeAPI(data) {
  return request({
    url: userBaseUrl_k8s + 'v1/user/password/getVerificationCode',
    method: 'post',
    data,
  })
}
/**
 * 个人中心-修改密码获取验证码
 */
export function getVerificationCodeToUpdateAPI(data) {
  return request({
    url: userBaseUrl_k8s + 'v1/user/password/getLoginResetVerificationCode',
    method: 'post',
    data,
  })
}
/**
 * 个人中心-修改密码
 */
export function updatePasswordAPI(data) {
  return request({
    url: userBaseUrl_k8s + 'v1/user/password/resetByPhoneAndVerificationCode',
    method: 'post',
    data,
  })
}
/**
 * 个人中心-取消授权
 */
export function cancelAuthAPI(data) {
  return request({
    url: userBaseUrl_k8s + 'v1/user/platform/authorize/cancel',
    method: 'post',
    data,
  })
}
/**
 * 用户功能
 */
export function userFunctionAPI(data) {
  return request({
    url: userBaseUrl_k8s + 'v1/user/userLevelFeature',
    method: 'post',
    data,
  })
}
